<template>
  <section class="testimonials" id="reviews">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">客户对我们的评价</h2>
        <p class="section-description">
          我们以客户满意为最高目标，通过专业的技术服务和贴心的客户支持，
          赢得了众多客户的信任和好评。
        </p>
      </div>
      <div class="testimonials-grid">
        <div class="testimonial-card" v-for="testimonial in testimonials" :key="testimonial.id">
          <div class="testimonial-rating">
            <span class="star" v-for="i in 5" :key="i">★</span>
          </div>
          <div class="testimonial-content">
            <p class="testimonial-text">{{ testimonial.text }}</p>
          </div>
          <div class="testimonial-author">
            <div class="author-avatar">
              <div class="avatar-placeholder">{{ testimonial.avatar }}</div>
            </div>
            <div class="author-info">
              <div class="author-name">{{ testimonial.name }}</div>
              <div class="author-role">{{ testimonial.role }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TestimonialsSection',
  data() {
    return {
      testimonials: [
        {
          id: 1,
          text: "轻助帮助我们完成了数字化转型，他们的技术团队非常专业，项目交付质量超出预期。整个合作过程非常顺畅，强烈推荐！",
          name: "张总",
          role: "某大型零售企业CEO",
          avatar: "👨‍💼"
        },
        {
          id: 2,
          text: "从项目启动到最终上线，轻助团队展现了极高的专业水准。他们不仅技术过硬，更重要的是能够深入理解我们的业务需求。",
          name: "李经理",
          role: "某跨境物流公司CEO",
          avatar: "👩‍💻"
        },
        {
          id: 3,
          text: "合作一年多来，轻助始终保持着高质量的服务水准。他们的响应速度很快，解决问题的能力也很强，是我们值得信赖的合作伙伴。",
          name: "王总监",
          role: "某制造企业IT总监",
          avatar: "👨‍🔧"
        }
      ]
    }
  }
}
</script>

<style scoped>
.testimonials {
  padding: 80px 0;
  background: #f8fafc;
  position: relative;
}

.testimonials::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, #d1d5db, transparent);
}

.testimonials::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, #d1d5db, transparent);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-header {
  text-align: center;
  margin-bottom: 64px;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 16px 0;
}

.section-description {
  font-size: 1.125rem;
  color: #6b7280;
  margin: 0;
  max-width: 600px;
  margin: 0 auto;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 32px;
}

.testimonial-card {
  background: white;
  padding: 32px;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.testimonial-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.testimonial-rating {
  margin-bottom: 20px;
}

.star {
  color: #fbbf24;
  font-size: 1.25rem;
  margin-right: 4px;
}

.testimonial-content {
  margin-bottom: 24px;
}

.testimonial-text {
  font-size: 1rem;
  line-height: 1.6;
  color: #374151;
  margin: 0;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 16px;
}

.author-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #8b5cf6, #ec4899);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.author-name {
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
}

.author-role {
  font-size: 0.875rem;
  color: #6b7280;
}

@media (max-width: 768px) {
  .testimonials {
    padding: 60px 0;
  }
  
  .testimonials-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  
  .testimonial-card {
    padding: 24px;
  }
  
  .section-title {
    font-size: 2rem;
  }
}
</style>
